import { useCallback } from 'react';

import qs from 'qs';
import { useHistory } from 'react-router-dom';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';

export const useQueryStringAndStoreHook = () => {
    const { updateBatch } = useGlobalFilterDataStore();
    const history = useHistory();

    const setBatchQuery = useCallback(
        (value) => {
            const existingQueries = qs.parse(window.location.search, {
                ignoreQueryPrefix: true,
            });

            const queryString = qs.stringify({ ...existingQueries, ...value }, { skipNulls: true, encode: true });
            history.replace({
                search: queryString,
            });
        },
        [history],
    );

    const setValueToQueryStringAndStore = (formValues) => {
        updateBatch(formValues);
        setBatchQuery(formValues);
    };

    return [setValueToQueryStringAndStore];
};
